var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/request-holiday-sent.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2336685e!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/request-holiday-sent.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RequestHolidaySent.vue
// module id = 1351
// module chunks = 1